module.exports = __webpack_public_path__ + "static/media/call_end-24px.39365fed.svg";